import { formatMoney } from '@/lib/money';
import { useI18n } from '@/client/i18n/I18nContext';

interface PriceProps {
  cents: number;
  currency?: string;
  compareAtCents?: number | null;
  /** When true (placeholder data), show a "price to be confirmed" label. */
  tbc?: boolean;
}

export function Price({ cents, currency = 'EUR', compareAtCents, tbc }: PriceProps) {
  const { t } = useI18n();
  if (tbc || cents <= 0) {
    return <span className="price price--tbc">{t('common.priceTbc')}</span>;
  }
  return (
    <span className="price">
      {formatMoney(cents, currency)}
      {compareAtCents && compareAtCents > cents ? (
        <span className="price__compare">{formatMoney(compareAtCents, currency)}</span>
      ) : null}
    </span>
  );
}
